import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useUserHistory, useUpdateDeleteStatus } from './UserDetailapi';
import { Search } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useToast } from '../../hooks/usetoast';
import { WaitingLoader } from '../../hooks/buttonLoad';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';

function DeleteRequestAccount() {
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);
    const { id } = useParams();
    const [loading, setLoading] = useState(false)

    const { data: getUserHistory, isLoading } = useUserHistory({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        userStatus: "Pending",
        sortField: "createdAt",
        sortOrder: "desc"
    })

    const totalRecords = getUserHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const updateStatus = useUpdateDeleteStatus()
    const toast = useToast()

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure you want to delete this account?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);

                    const res = await updateStatus.mutateAsync({
                        id: id,
                        status: "Deleted"

                    });

                    if (!res?.data?.status) {
                        setLoading(false);
                        return toast.error(res?.data?.message);
                    }

                    toast.success(res?.data?.message);
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                }
            }
        });
    }



    const handleReject = (id) => {
        Swal.fire({
            title: "Are you sure you want to Reject this request?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Reject it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);

                    const res = await updateStatus.mutateAsync({
                        id: id,
                        status: "Rejected"

                    });

                    if (!res?.data?.status) {
                        setLoading(false);
                        return toast.error(res?.data?.message);
                    }

                    toast.success(res?.data?.message);
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                }
            }
        });
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'User Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderUserHistoryTable = () => (
        getUserHistory?.data?.usersHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>

                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.NO</TableCell>
                                    <TableCell align="center">User Name</TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Email Verified</TableCell>
                                    <TableCell align="center">Mobile Verified</TableCell>
                                    <TableCell align="center">KYC Status</TableCell>
                                    <TableCell align="center">Date and Time </TableCell>
                                    <TableCell align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getUserHistory?.data?.usersHistory?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row?.userName}</TableCell>
                                        <TableCell align="center">{row?.email}</TableCell>
                                        <TableCell align="center">{row?.isEmailVerified ? "Yes" : "No"}</TableCell>
                                        <TableCell align="center">{row?.isMobileVerified ? "Yes" : "No"}</TableCell>
                                        <TableCell align="center">{row?.isKycStatus}</TableCell>


                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>

                                        <TableCell align="center" className=' text-center'>
                                            <div className="d-flex justify-content-center">
                                                <button className="btn btn-primary d-flex align-items-center" onClick={() => handleDelete(row._id)}>
                                                    Delete
                                                </button>
                                                <button className="btn btn-secondary d-flex align-items-center ms-3" onClick={() => handleReject(row._id)}>
                                                    Reject
                                                </button>
                                            </div>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    let content;

    if (loading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <section>
                <h4>Delete Requested Account</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color='#aaa9a9' />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    value={search}
                                    className="form-control"
                                    placeholder="Search by name , email"
                                />
                            </div>
                        </div>
                    </div>
                    {isLoading ? <PageLoader /> : renderUserHistoryTable()}
                </div>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;
}

export default DeleteRequestAccount